import { render } from "./LivePrice.vue?vue&type=template&id=1fff713c"
import script from "./LivePrice.vue?vue&type=script&setup=true&lang=js"
export * from "./LivePrice.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/LivePrice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fff713c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fff713c', __exports__)) {
    api.reload('1fff713c', __exports__)
  }
  
  module.hot.accept("./LivePrice.vue?vue&type=template&id=1fff713c", () => {
    api.rerender('1fff713c', render)
  })

}


export default __exports__